import { createRoute } from '@tanstack/react-router';
import { MiceNewProjectPage, MiceProjectPage, MiceProjectsPage } from '@web/ui/mice';
import { orgWorkspaceLayoutRoute } from './overview_routes';
import { requireOrgPermission } from './org_permission_guard';

/** `/orgs/$orgSlug/mice` — projetos de compra em lote (spec 2026-10-15). */
export const miceProjectsRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'mice',
  component: MiceProjectsPage,
  beforeLoad: ({ params }) => requireOrgPermission(params.orgSlug, 'mice:read'),
});

export const miceNewProjectRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'mice/new',
  component: MiceNewProjectPage,
  beforeLoad: ({ params }) => requireOrgPermission(params.orgSlug, 'mice:manage'),
});

export const miceProjectRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'mice/$projectId',
  component: MiceProjectPage,
  beforeLoad: ({ params }) => requireOrgPermission(params.orgSlug, 'mice:read'),
});
